import MuiCardMedia, { CardMediaProps as MuiCardMediaProps } from '@mui/material/CardMedia';

export type CardMediaProps = MuiCardMediaProps;

export const CardMedia = (props: CardMediaProps) => {
  return <MuiCardMedia {...props} />;
};
